const CONSTANT = {
    ACCOUNT: {
        CREATE: 'create your account',
        LOGIN: 'login',
        FORGOT: 'forgot password',
    },
    APPOINTMENT_DATE_FORMAT: 'YYYY-MM-DD',
    OFFICIAL_FORM_STATUS: {
        ALL_COMPLETED: 'COMPLETED',
        NOT_COMPLETED: 'STARTED',
        NOT_STARTED: 'NOT_STARTED',
    },
    TRANSACTION: {
        GARAGE: {
            TITLE: 'garage',
            CTA: {
                NEW: 'add a new car',
                USED: 'add a used car',
            },
        },
        TRADEIN: {
            TITLE: 'tradein',
            INSTANT: 'instant value',
            OFFICIAL: 'official value',
        },
        FINANCE: {
            TITLE: 'finance',
            APPLY_NOW: 'apply now',
        },
    },
};

export default CONSTANT;
